import { Map } from 'immutable';
import _ from 'lodash';

import BaseStore from './BaseStore';
import {
    ActionTypes,
    StationTypes,
    SmartcardStationTypes,
    SeasonStationTypes,
    SmartcardSeasonStationTypes,
    DaySaveStationTypes,
    DelayRepayStationTypes,
    RecentStationsTypes
} from '../constants/AppConstants';
import RecentStations from '../records/RecentStations';

export const stationsMap = new Map({
    [StationTypes.ORIGIN]: [RecentStationsTypes.POINT, StationTypes.ORIGIN],
    [StationTypes.DESTINATION]: [RecentStationsTypes.POINT, StationTypes.DESTINATION],
    [StationTypes.VIAAVOID]: [RecentStationsTypes.POINT, StationTypes.VIAAVOID],

    [SmartcardStationTypes.ORIGIN]: [RecentStationsTypes.SMARTCARD, StationTypes.ORIGIN],
    [SmartcardStationTypes.DESTINATION]: [RecentStationsTypes.SMARTCARD, StationTypes.DESTINATION],
    [SmartcardStationTypes.VIAAVOID]: [RecentStationsTypes.SMARTCARD, StationTypes.VIAAVOID],

    [SeasonStationTypes.ORIGIN]: [RecentStationsTypes.SEASON, StationTypes.ORIGIN],
    [SeasonStationTypes.DESTINATION]: [RecentStationsTypes.SEASON, StationTypes.DESTINATION],

    [SmartcardSeasonStationTypes.ORIGIN]: [RecentStationsTypes.SMARTCARDSEASON, StationTypes.ORIGIN],
    [SmartcardSeasonStationTypes.DESTINATION]: [RecentStationsTypes.SMARTCARDSEASON, StationTypes.DESTINATION],

    [DaySaveStationTypes.ORIGIN]: [RecentStationsTypes.DAYSAVE, StationTypes.ORIGIN],

    [DelayRepayStationTypes.ORIGIN]: [RecentStationsTypes.DELAY_REPAY, StationTypes.ORIGIN],
    [DelayRepayStationTypes.DESTINATION]: [RecentStationsTypes.DELAY_REPAY, StationTypes.DESTINATION],
    [DelayRepayStationTypes.VIAAVOID]: [RecentStationsTypes.DELAY_REPAY, StationTypes.VIAAVOID]
});

export const stationsKeys = new Map({
    [RecentStationsTypes.POINT]: StationTypes,
    [RecentStationsTypes.SEASON]: SeasonStationTypes,
    [RecentStationsTypes.SMARTCARD]: SmartcardStationTypes,
    [RecentStationsTypes.SMARTCARDSEASON]: SmartcardSeasonStationTypes,
    [RecentStationsTypes.DAYSAVE]: DaySaveStationTypes
});

const recentStations = new Map({
    [RecentStationsTypes.POINT]: RecentStations,
    [RecentStationsTypes.SEASON]: RecentStations,
    [RecentStationsTypes.SMARTCARD]: RecentStations,
    [RecentStationsTypes.SMARTCARDSEASON]: RecentStations,
    [RecentStationsTypes.DAYSAVE]: RecentStations
});

const _getDefaultState = () => recentStations.map((Type) => new Type());

const _prepStations = (key, type, stations, searchStation) => {
    const validityKey = stationsKeys.get(key)[type];
    if (!searchStation || searchStation.isEmpty() || !searchStation.getIn(['validity', validityKey])) {
        return stations;
    }

    let output = stations;
    const index = output.findIndex(val => val.equals(searchStation));

    if (index >= 0) { output = output.delete(index); }
    if (output.count() === 5) { output = output.shift(); }

    return output.push(searchStation);
};

export class RecentStationsStore extends BaseStore {

    deserialize(serialized) {
        let state = _getDefaultState();

        if (serialized) {
            _.forEach(serialized, (value, key) => {
                if (state.has(key)) {
                    const RecentStationsClass = recentStations.get(key);
                    state = state.set(key, RecentStationsClass.fromJSON(value));
                }
            });
        }

        return state;
    }

    get(stationType = StationTypes.ORIGIN) {
        return this.state.getIn(stationsMap.get(stationType));
    }

    handleSearchStarted({ search }) {
        let state = this.state;
        const {
            origin: searchOrigin,
            destination: searchDestination,
            via: searchVia,
            avoid: searchAvoid
        } = search;
        const searchViaAvoid = searchVia && searchVia.isEmpty() ? searchAvoid : searchVia;

        state = state.reduce(
            (acc, {[StationTypes.ORIGIN]: origin, [StationTypes.DESTINATION]: destination, [StationTypes.VIAAVOID]: viaAvoid }, key) => {
                return acc.set(key,
                    new RecentStations({
                        [StationTypes.ORIGIN]: _prepStations(key, 'ORIGIN', origin, searchOrigin),
                        [StationTypes.DESTINATION]: _prepStations(key, 'DESTINATION', destination, searchDestination),
                        [StationTypes.VIAAVOID]: _prepStations(key, 'VIAAVOID', viaAvoid, searchViaAvoid)
                    })
                );
            }, state);

        this.setState(state);
    }

    getActionHandlers() {
        return {
            [ActionTypes.SEARCH_STARTED]: this.handleSearchStarted,
            [ActionTypes.SEASON_SEARCH_STARTED]: this.handleSearchStarted,
            [ActionTypes.FARE_ONLY_SEARCH_STARTED]: this.handleSearchStarted,
            [ActionTypes.FARE_ONLY_SEASON_SEARCH_STARTED]: this.handleSearchStarted,
            [ActionTypes.DAYSAVE_SEARCH_STARTED]: this.handleSearchStarted
        };
    }
}

const instance = new RecentStationsStore({ storageKey: 'recent-stations' });

export default instance;



// WEBPACK FOOTER //
// ./src/stores/RecentStationsStore.js